import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import "./ProfileView.css";

class ProfileView extends Component {
  constructor(props) {
    super(props);

    this.fileInputRef = React.createRef();

    this.state = {
      fullName: "",
      dob: "",
      phone: "",
      email: "",
      customer_image: "",

      isEditing: false,

      originalProfile: {
        fullName: "",
        dob: "",
        phone: "",
        email: "",
        customer_image: ""
      },

      loading: false,
      saving: false
    };
  }

  componentDidMount() {
    const web_user_id = localStorage.getItem("web_user_id");
    if (!web_user_id) {
      window.location.href = "/login";
      return;
    }
    this.fetchProfileData();
  }

  fetchProfileData = async () => {
    try {
      this.setState({ loading: true });
      const web_user_id = localStorage.getItem("web_user_id");
      if (!web_user_id) return;

      const response = await axios.get(`/profile_data/${web_user_id}`);
      const data = response?.data?.data;

      if (!data) return;

      const profileData = {
        fullName: data.full_name || "",
        dob: data.dateofbirth || "",
        phone: data.phone || "",
        email: data.email || "",
        customer_image: data.customer_image || ""
      };

      this.setState({
        ...profileData,
        originalProfile: { ...profileData }
      });
    } catch (error) {
      console.error("Profile fetch error:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleAvatarClick = () => {
    if (this.fileInputRef.current) {
      this.fileInputRef.current.click();
    }
  };

  handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const web_user_id = localStorage.getItem("web_user_id");
    if (!web_user_id) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      const response = await axios.post(
        `/upload_profile_image/${web_user_id}`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.status === 200 || response.data?.success) {
        alert("Profile image updated successfully!");
        await this.fetchProfileData();
      }
    } catch (error) {
      console.error("Image upload failure:", error);
      alert("Failed to upload image. Please try again.");
    } finally {
      if (this.fileInputRef.current) {
        this.fileInputRef.current.value = "";
      }
    }
  };

  handleSave = async (e) => {
    e.preventDefault();
    const { fullName, email, dob } = this.state;
    const web_user_id = localStorage.getItem("web_user_id");

    if (!web_user_id) return;

    const cleanFullName = fullName.trim().replace(/\s+/g, " ");
    const formData = new FormData();

    formData.append("id", web_user_id);
    formData.append("full_name", cleanFullName);
    formData.append("email", email);
    formData.append("dateofbirth", dob);

    try {
      this.setState({ saving: true });

      await axios.post("profile_save", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      await this.fetchProfileData();
      this.setState({ isEditing: false });
      alert("Profile updated successfully!");
    } catch (error) {
      console.error("Profile save error:", error);
      alert("Failed to save profile. Please try again.");
    } finally {
      this.setState({ saving: false });
    }
  };

  handleCancel = () => {
    this.setState((prevState) => ({
      fullName: prevState.originalProfile.fullName,
      dob: prevState.originalProfile.dob,
      phone: prevState.originalProfile.phone,
      email: prevState.originalProfile.email,
      customer_image: prevState.originalProfile.customer_image,
      isEditing: false
    }));
  };

  // SVG Icons
  UserIcon = () => (
    <svg viewBox="0 0 24 24">
      <circle cx="12" cy="8" r="3.2" fill="none" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M5.5 20c.7-3.6 2.8-5.5 6.5-5.5s5.8 1.9 6.5 5.5" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );

  CalendarIcon = () => (
    <svg viewBox="0 0 24 24">
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8"/>
      <path d="M7.5 3v4M16.5 3v4M3.5 9.5h17" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
    </svg>
  );

  PhoneIcon = () => (
    <svg viewBox="0 0 24 24">
      <path d="M7 4.5c.5-.4 1.2-.3 1.6.3l2 3.1c.4.6.3 1.3-.2 1.8l-1.2 1.1c.9 1.8 2.3 3.2 4.1 4.1l1.1-1.2c.5-.5 1.2-.6 1.8-.2l3.1 2c.6.4.7 1.1.3 1.6l-1.1 1.5c-.5.7-1.3 1-2.1.8-6.7-1.7-11.6-6.6-13.3-13.3-.2-.8.1-1.6.8-2.1L7 4.5Z" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  MailIcon = () => (
    <svg viewBox="0 0 24 24">
      <rect x="3" y="5" width="18" height="14" rx="2" fill="none" stroke="currentColor" strokeWidth="1.8"/>
      <path d="m4 7 8 6 8-6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  EditIcon = () => (
    <svg viewBox="0 0 24 24">
      <path d="m14.5 5.5 4 4M5 19l1.2-4.4L16.8 4a2.2 2.2 0 0 1 3.2 3.2L9.4 17.8 5 19Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  PencilBadgeIcon = () => (
    <svg viewBox="0 0 24 24">
      <path d="M15.2 3a2.1 2.1 0 0 1 3 3L7.5 16.7 3 18l1.3-4.5L15.2 3z" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  CheckIcon = () => (
    <svg viewBox="0 0 24 24">
      <path d="m5 12.5 4.5 4.5L19 7.5" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );

  CloseIcon = () => (
    <svg viewBox="0 0 24 24">
      <path d="m6 6 12 12M18 6 6 18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  );

  renderAvatar = () => {
    const { fullName, customer_image } = this.state;

    return (
      <div className="profile-avatar-wrapper">
        <div className="profile-avatar">
          {customer_image ? (
            <img src={customer_image} alt="Profile" className="profile-avatar-image" />
          ) : (
            <span>{fullName ? fullName.charAt(0).toUpperCase() : "U"}</span>
          )}
        </div>

        <input
          ref={this.fileInputRef}
          type="file"
          accept="image/*"
          className="file-input-hidden"
          onChange={this.handleFileChange}
        />

        <button
          type="button"
          className="avatar-edit-badge"
          onClick={this.handleAvatarClick}
          title="Change profile picture"
        >
          <this.PencilBadgeIcon />
        </button>
      </div>
    );
  };

  renderField = ({ label, name, value, type = "text", icon: Icon, disabled = false, placeholder = "" }) => (
    <div className="form-field-group">
      <label htmlFor={name}>{label}</label>
      <div className={`input-wrapper ${disabled ? "input-disabled" : ""}`}>
        <span className="input-icon">
          <Icon />
        </span>
        <input
          id={name}
          type={type}
          name={name}
          value={value}
          onChange={this.handleChange}
          placeholder={placeholder}
          disabled={disabled}
        />
      </div>
    </div>
  );

  render() {
    const { fullName, email, phone, dob, isEditing, loading, saving } = this.state;

    return (
      <div className="profile-container">
        {loading ? (
          <div className="profile-loading-state">
            <div className="profile-spinner" />
            <p>Loading profile information...</p>
          </div>
        ) : (
          <div className="profile-card">
            {/* Header / Avatar */}
            <div className="profile-header">
              {this.renderAvatar()}
              <div className="profile-header-info">
                <h2>{fullName || "User Profile"}</h2>
                <p>{email || "No email provided"}</p>
              </div>

              {!isEditing && (
                <button
                  type="button"
                  className="btn-primary"
                  onClick={() => this.setState({ isEditing: true })}
                >
                  <this.EditIcon /> Edit Profile
                </button>
              )}
            </div>

            {/* Content: View or Edit */}
            {isEditing ? (
              <form onSubmit={this.handleSave} className="profile-form">
                <div className="form-grid">
                  {this.renderField({
                    label: "Full Name",
                    name: "fullName",
                    value: fullName,
                    icon: this.UserIcon,
                    placeholder: "Enter full name"
                  })}

                  {this.renderField({
                    label: "Date of Birth",
                    name: "dob",
                    value: dob,
                    type: "date",
                    icon: this.CalendarIcon
                  })}

                  {this.renderField({
                    label: "Phone Number",
                    name: "phone",
                    value: phone,
                    type: "tel",
                    icon: this.PhoneIcon,
                    disabled: true
                  })}

                  <div className="form-field-group">
                    <label>Email Address</label>
                    <div className="input-wrapper input-disabled">
                      <span className="input-icon">
                        <this.MailIcon />
                      </span>
                      <input type="email" value={email} disabled placeholder="Email address" />
                      <span className="readonly-badge">Read Only</span>
                    </div>
                  </div>
                </div>

                <div className="form-actions">
                  <button
                    type="button"
                    className="btn-secondary"
                    onClick={this.handleCancel}
                    disabled={saving}
                  >
                    <this.CloseIcon /> Cancel
                  </button>

                  <button
                    type="submit"
                    className="btn-primary"
                    disabled={saving}
                  >
                    {saving ? (
                      <>
                        <span className="btn-spinner" /> Saving...
                      </>
                    ) : (
                      <>
                        <this.CheckIcon /> Save Changes
                      </>
                    )}
                  </button>
                </div>
              </form>
            ) : (
              <div className="profile-overview-grid">
                <div className="info-box">
                  <span className="info-label">Full Name</span>
                  <span className="info-value">{fullName || "Not provided"}</span>
                </div>

                <div className="info-box">
                  <span className="info-label">Date of Birth</span>
                  <span className="info-value">{dob || "Not provided"}</span>
                </div>

                <div className="info-box">
                  <span className="info-label">Phone Number</span>
                  <span className="info-value">{phone || "Not provided"}</span>
                </div>

                <div className="info-box">
                  <span className="info-label">Email Address</span>
                  <span className="info-value">{email || "Not provided"}</span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default ProfileView;

